import { Checkbox, DataHeader, DataSource, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLateRouteControl extends Layout {
    checkboxDriverCallinAdd: Checkbox;
    checkboxPositionAdd: Checkbox;
    checkboxPositionExcludeTrlr: Checkbox;
    checkboxPreassignmentAdd: Checkbox;
    checkboxStopAdd: Checkbox;
    checkboxStopDateUpdate: Checkbox;
    checkboxStopStatusUpdate: Checkbox;
    dataheaderLateRouteControl: DataHeader;
    panelEventLeft: Panel;
    panelEventRight: Panel;
    panelEventTriggers: Panel;
    panelFirstRow: Panel;
    panelGeneralFields: Panel;
    panelSecondRow: Panel;
    panelThirdRow: Panel;
    sourceLateRouteControl: DataSource;
    switchClearViaPoint: Switch;
    switchConsiderDrvHours: Switch;
    switchSubsequentEta: Switch;
    tabEventStatusTriggers: Tab;
    tabGeneral: Tab;
    tabsetLateRouteControl: Tabset;
    textboxDefaultLoading: Textbox;
    textboxDistanceOor: Textbox;
    textboxEmailError: Textbox;
    textboxLateRouteStatus: Textbox;
    textboxLogDetailLevel: Textbox;
    textboxMaxLoadingTime: Textbox;
    textboxMaxPointRadius: Textbox;
    textboxMinLoadingTime: Textbox;
    textboxMinPointRadius: Textbox;
    textboxMinToleranceErly: Textbox;
    textboxMinToleranceLate: Textbox;
    textboxMinuteBeforeEta: Textbox;
    textboxOorPercentage: Textbox;
    textboxViaPointClearRadius: Textbox;
}
